(() => {
  const VARIANT_ATTR = 'testLowStockV2';
  const VARIANT_VALUE = 'b';
  const STORAGE_PREFIX = 'pl_count_';

  const isVariantB = () => document.body.dataset[VARIANT_ATTR] === VARIANT_VALUE;

  const pickCount = (productId, min, max) => {
    const key = STORAGE_PREFIX + productId;
    let stored;
    try { stored = sessionStorage.getItem(key); } catch (e) {}
    const parsed = parseInt(stored, 10);
    if (Number.isFinite(parsed) && parsed >= min && parsed <= max) return parsed;
    const next = Math.floor(Math.random() * (max - min + 1)) + min;
    try { sessionStorage.setItem(key, String(next)); } catch (e) {}
    return next;
  };

  const reveal = (root) => {
    root.dataset.randomApplied = 'true';
  };

  const applyRandom = () => {
    const roots = document.querySelectorAll('[data-people-looking-root][data-random-enabled="true"]');
    if (!roots.length) return;

    if (!isVariantB()) {
      roots.forEach(reveal);
      return;
    }

    roots.forEach((root) => {
      const min = parseInt(root.dataset.randomMin, 10);
      const max = parseInt(root.dataset.randomMax, 10);
      const productId = root.dataset.productId;
      const textEl = root.querySelector('.people-looking__text');

      if (!textEl || !productId || !Number.isFinite(min) || !Number.isFinite(max) || min > max) {
        reveal(root);
        return;
      }

      const count = pickCount(productId, min, max);
      textEl.innerHTML = textEl.innerHTML.replace(/\d+/, count);
      reveal(root);
    });
  };

  const init = () => {
    applyRandom();
    document.addEventListener('growthbookdata', applyRandom);

    new MutationObserver(applyRandom).observe(document.body, {
      attributes: true,
      attributeFilter: ['data-test-low-stock-v2'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
